import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const UserGroupIcon = {
  name: 'UserGroupIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "55.786",
        height: "41.787",
        viewBox: "0 0 55.786 41.787",
        fill: "currentColor",
        stroke: "none"
      },
      "class": "feather feather-user-group"
    }, ctx.data]), [
      h("g", {
        attrs: {
          transform: "translate(0 0)"
        }
      }, [
        h("path", {
          attrs: {
            d: "M98.877,0a10.051,10.051,0,0,1,5.011,1.337,10.316,10.316,0,0,1,1.376.955q.373.308.714.649a10.044,10.044,0,0,1,1.032,12.991,10.312,10.312,0,0,1-1.032,1.211l-.133.131A10.04,10.04,0,0,1,90.8,16.008l-.09-.121a10.042,10.042,0,0,1,.838-12.715l.224-.232a9.652,9.652,0,0,1,.8-.717A10.063,10.063,0,0,1,98.877,0Zm0,19.3a9.222,9.222,0,0,0,6.429-2.594l.12-.118a9.147,9.147,0,0,0,.9-1.044,9.263,9.263,0,0,0-.9-12.056q-.314-.314-.658-.6a9.529,9.529,0,0,0-1.27-.882A9.269,9.269,0,0,0,98.877.778a9.157,9.157,0,0,0-5.814,2.052,8.887,8.887,0,0,0-.736.66l-.206.213a9.262,9.262,0,0,0-.775,11.729l-.23.343.313-.232A9.3,9.3,0,0,0,98.877,19.3Z",
            transform: "translate(-77.294 0.001)"
          }
        }),
        h("path", {
          attrs: {
            d: "M43.164,179.654H0L2.485,166.9A10.565,10.565,0,0,1,12.9,158.452h17.36A10.565,10.565,0,0,1,40.679,166.9ZM.955,178.867H42.208l-2.3-11.817a9.776,9.776,0,0,0-9.644-7.81H12.9a9.776,9.776,0,0,0-9.644,7.81Z",
            transform: "translate(0.001 -137.867)"
          }
        }),
        h("path", {
          attrs: {
            d: "M239.334,51.379a8.417,8.417,0,0,1-6.746-3.4l-.082-.11a8.365,8.365,0,0,1-.832-1.449l.594-.266A7.741,7.741,0,0,0,244.7,48.561l.331.132-.231-.23a7.956,7.956,0,0,0,.751-.873,7.742,7.742,0,0,0-.751-10.071c-.175-.175-.36-.342-.551-.5a7.949,7.949,0,0,0-1.061-.737,7.748,7.748,0,0,0-3.86-1.029,7.651,7.651,0,0,0-4.858,1.715,7.57,7.57,0,0,0-.615.551l-.171.177-.48-.441.19-.2a8.217,8.217,0,0,1,.667-.6,8.4,8.4,0,0,1,9.452-.743,8.611,8.611,0,0,1,1.15.8c.207.172.407.353.6.542a8.393,8.393,0,0,1,.862,10.853,8.885,8.885,0,0,1-.862,1.012l-.11.107A8.353,8.353,0,0,1,239.334,51.379Z",
            transform: "translate(-201.577 -30.106)"
          }
        }),
        h("path", {
          attrs: {
            d: "M302.745,184.7h-12.4v-.658h11.606l-1.923-9.872a8.168,8.168,0,0,0-8.058-6.524h-8.134v-.658h8.134a8.827,8.827,0,0,1,8.7,7.056Z",
            transform: "translate(-246.959 -145.292)"
          }
        })
      ])
    ]);
  }
};

export default UserGroupIcon;